import { startCollection, flushSync } from './sheet';

/**
 * Collect all CSS generated by executing one or more loader functions.
 *
 * This is a low-level primitive intended for build tools (Vite, Next.js, etc.)
 * to implement a zero-runtime extraction step.
 *
 * Example usage (Vite/Node):
 *
 * ```ts
 * import { collectStylesFromModules } from 'typestyles/build';
 *
 * const css = await collectStylesFromModules([
 *   () => import('./src/styles'),
 *   () => import('./src/tokens'),
 * ]);
 * ```
 */
export async function collectStylesFromModules(
  loaders: Array<() => unknown | Promise<unknown>>,
): Promise<string> {
  const endCollection = startCollection();

  for (const load of loaders) {
    // Each loader can synchronously or asynchronously import modules that
    // register typestyles styles, tokens, keyframes, etc.
    // We await in case a loader returns a promise (e.g. dynamic import).
    // The return value itself is ignored; only the side effects matter.
    await load();
  }

  flushSync();
  return endCollection();
}
